import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import NoventaLogo from '../../assets/images/noventa.svg';
import Grid from 'styled-components-grid';

const Wrapper = styled(Grid)`
  height: ${({theme}) => theme.spacingVertical(8)};
  background-color: ${({theme}) => theme.white};
  padding: ${({theme}) => theme.spacingVertical(2)} ${({theme}) => theme.spacingHorizontal(2)};
`;

const Logo = styled.img`
  height: 45px;
  margin-left: ${({theme}) => theme.spacingHorizontal()};
`;

const Column = styled(Grid.Unit).attrs({size: 1 / 3})``;

const CenterColumn = styled(Column)`
  text-align: center;
`;

const RightColumn = styled(Column)`
  text-align: right;
`;

const Toolbar = props => (
  <Wrapper>
    <Column>{props.renderLeftContent()}</Column>
    <CenterColumn>{props.renderCenterContent()}</CenterColumn>
    <RightColumn>
      {props.renderRightContent()}
      <Logo src={NoventaLogo} />
    </RightColumn>
  </Wrapper>
);

Toolbar.propTypes = {
  renderLeftContent: PropTypes.func,
  renderCenterContent: PropTypes.func,
  renderRightContent: PropTypes.func,
};

const renderNothing = () => {};

Toolbar.defaultProps = {
  renderLeftContent: renderNothing,
  renderCenterContent: renderNothing,
  renderRightContent: renderNothing,
};

export default Toolbar;
